


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { centsToEuro, currency } from '@/filters/currency';
import Fieldset from '@/components/common/Fieldset.vue';
import { SellOffer } from '@/store/sellOffer/types';
import { Asset } from '@/store/asset/types';

@Component({
  name: 'sell-offer-details',
  components: {
    Fieldset,
  },
  filters: {
    centsToEuro,
    currency,
  },
})
export default class SellOfferDetails extends Vue {
  @Prop({ required: true })
  sellOffer: SellOffer;

  @Prop({ required: true })
  asset: Asset;
}
